import { Navigate } from 'react-router';
import { INNSPILL } from './rom.ts';
import { useTilgang } from './tilgang.ts';

/**
 * Forsiden følger tilgangen (ux-design.md 2.2; H2.2): Innboks for dem som svarer på innspill,
 * Mine hypoteser for en bidragsyter som bare har rommet Hypoteser. Skallet tegner ingen side
 * før «meg» har svart, så tilgangen er kjent her. /h velger rommets egen forside etter rollen
 * (H2.3: Innboks for behandler og eier, Mine hypoteser for bidragsyter og leser).
 */
export function Forside() {
  const tilgang = useTilgang();
  const til = !tilgang.kanSe(INNSPILL) && tilgang.kanSe('hypoteser') ? '/h' : '/innboks';
  return <Navigate to={til} replace />;
}
